(function() { window.GUID_5a85a61f_844e_4bf9_a221_51f81e893a8f = { getGuid: function() { return "5a85a61f-844e-4bf9-a221-51f81e893a8f"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OpponentsFiltersPreset;
        (function (OpponentsFiltersPreset) {
            OpponentsFiltersPreset[OpponentsFiltersPreset["MyDivisions"] = 0] = "MyDivisions";
            OpponentsFiltersPreset[OpponentsFiltersPreset["MyFriendsAndFavorites"] = 1] = "MyFriendsAndFavorites";
            OpponentsFiltersPreset[OpponentsFiltersPreset["SparesForDivisions"] = 2] = "SparesForDivisions";
            OpponentsFiltersPreset[OpponentsFiltersPreset["Custom"] = 3] = "Custom";
        })(OpponentsFiltersPreset = Enumeration.OpponentsFiltersPreset || (Enumeration.OpponentsFiltersPreset = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OpponentsFiltersPreset.pre.js.map
